import "core-js/modules/es6.function.name.js";
var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c('div', {
    staticClass: "footer--language",
    on: {
      "click": function click($event) {
        _vm.isOpen = !_vm.isOpen;
      }
    }
  }, [_c('div', {
    staticClass: "footer--language-current"
  }, [_c('div', {
    staticClass: "position-relative m-auto"
  }, [_c('img', {
    staticClass: "lazyload",
    class: _vm.marketLanguage,
    attrs: {
      "src": _vm.spriteFlag,
      "loading": "lazy"
    }
  }), _vm._v(" "), _c('span', [_vm._v(_vm._s(_vm.currentLocale.market))])])]), _vm._v(" "), _c('mdm-icon', {
    staticClass: "fill-white",
    class: "icon icon-item rotate ".concat(_vm.position),
    attrs: {
      "name": "chevron-bottom-doodle"
    }
  }), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: _vm.isOpen,
      expression: "isOpen"
    }],
    key: "1",
    staticClass: "footer--language-list"
  }, [_vm._l(_vm.otherLocales, function (locale, key) {
    return _c('li', {
      key: key
    }, [_c('a', {
      attrs: {
        "href": _vm.changeLocale(locale)
      }
    }, [_c('img', {
      class: "market-".concat(locale.market),
      attrs: {
        "src": _vm.spriteFlag,
        "loading": "lazy",
        "alt": ""
      }
    }), _vm._v("\n        " + _vm._s(locale.name) + "\n      ")])]);
  }), _vm._v(" "), _c('li', [_c('a', {
    attrs: {
      "href": _vm.changeLocale({
        market: 'US'
      })
    },
    domProps: {
      "textContent": _vm._s('United States')
    }
  }), _vm._v(" "), _c('img', {
    staticClass: "market-US",
    attrs: {
      "src": _vm.spriteFlag,
      "loading": "lazy",
      "alt": ""
    }
  })])], 2)], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };